import axios from 'axios'
import pageKeys from '../common/pagekeys'

export default {
    async getAll() {
        try
        {            
            const response = await axios.get(`Reimbursements`,
            {
                headers: {
                    'page_key': pageKeys.reimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getAll api error')
            throw error
        }
    },    
    async getDetail(reimbursementsId) {
        try
        {            
            const response = await axios.get(`Reimbursements/${reimbursementsId}`,
            {
                headers: {
                    'page_key': pageKeys.reimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getDetail api error')
            throw error
        }
    }, 
    async getMyReimbursements() {
        try
        {            
            const response = await axios.get(`Reimbursements/myreimbursements`,
            {
                headers: {
                    'page_key': pageKeys.myreimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getMyReimbursements api error')
            throw error
        }
    },    
    async getMyReimbursementsDetail(reimbursementsId) {
        try
        {            
            const response = await axios.get(`Reimbursements/${reimbursementsId}`,
            {
                headers: {
                    'page_key': pageKeys.myreimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getMyReimbursementsDetail api error')
            throw error
        }
    }, 
    async getTypes() {
        try
        {            
            const response = await axios.get(`Reimbursements/types`,
            {
                headers: {
                    'page_key': pageKeys.myreimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getTypes api error')
            throw error
        }
    },
    async add(data, pageKey) {
        try
        {            
            const response = await axios.post(`Reimbursements`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements add api error')
            throw error
        }
    },
    async update(data, pageKey) {
        try
        {            
            const response = await axios.patch(`Reimbursements`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements update api error')
            throw error
        }
    },
    async saveAttachment(data) {
        try
        {            
            const response = await axios.post(`Reimbursements/attachment/save`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.myreimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements saveAttachment api error')
            throw error
        }
    },
    async downloadAttachments(reimbursementAttachmentId, userId, pageKey) {
        try
        {            
            const response = await axios.get(`Reimbursements/attachments/download/${reimbursementAttachmentId}/${userId}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements deleteAttachment api error')
            throw error
        }
    },
    async getAttachmentUrl(userId, fileName, pageKey) {
        try
        {            
            const response = await axios.post(`Reimbursements/attachment/pre-signed-url`,
            {
                userId: userId,
                fileName: fileName
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements getAttachmentUrl api error')
            throw error
        }
    },
    async deleteAttachment(reimbursementAttachmentId) {
        try
        {            
            const response = await axios.post(`Reimbursements/attachment/delete/${reimbursementAttachmentId}`,
            {},
            {
                headers: {
                    'page_key': pageKeys.myreimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements deleteAttachment api error')
            throw error
        }
    },
    async setForReview(data, pageKey) {
        try
        {            
            const response = await axios.post(`Reimbursements/forreview`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements setForReview api error')
            throw error
        }
    },
    async approve(data) {
        try
        {            
            const response = await axios.post(`Reimbursements/approve`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.reimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements approve api error')
            throw error
        }
    },
    async reject(data) {
        try
        {            
            const response = await axios.post(`Reimbursements/reject`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.reimbursements
                }
            })             
            return response
        }
        catch (error)
        {
            console.log('Reimbursements reject api error')
            throw error
        }
    },
}
